import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router'

const usePreviousPath = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const generatePreviousPath = useCallback(
    (fallbackPath: string) => (location.key === 'default' ? fallbackPath : -1),
    [location.key],
  )
  const navigateToPrevious = useCallback(
    (fallbackPath: string) => {
      location.key === 'default' ? navigate(fallbackPath) : navigate(-1)
    },
    [location.key, navigate],
  )
  return {
    generatePreviousPath,
    navigateToPrevious,
  }
}
export default usePreviousPath
